import moment from 'moment';

export const addDay = (inputDate = null, noOfDays = null) => {
    const date = moment(inputDate,"YYYY/MM/DD"); // Your date
    const nextDay = date.add(noOfDays, "days");
    return nextDay.format("YYYY/MM/DD")
}

export const getCurrentDate = () =>{
    return;
}